import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { ThemeProvider } from './context/ThemeContext';

// Public pages
import PublicLayout from './components/PublicLayout';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import PageDetail from './pages/PageDetail';
import References from './pages/References';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import BeforeAfterPage from './pages/BeforeAfterPage';
import BeforeAfterDetail from './pages/BeforeAfterDetail';
import UserReviews from './pages/UserReviews';
import NotFound from './pages/NotFound';

// Admin pages
import AdminLogin from './admin/pages/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
import AdminSettings from './admin/pages/AdminSettings';
import AdminSliders from './admin/pages/AdminSliders';
import AdminServices from './admin/pages/AdminServices';
import AdminPages from './admin/pages/AdminPages';
import AdminReferences from './admin/pages/AdminReferences';
import AdminMessages from './admin/pages/AdminMessages';
import AdminCounters from './admin/pages/AdminCounters';
import AdminTestimonials from './admin/pages/AdminTestimonials';
import AdminBeforeAfter from './admin/pages/AdminBeforeAfter';
import AdminQuotes from './admin/pages/AdminQuotes';
import AdminActivityLog from './admin/pages/AdminActivityLog';
import AdminUsers from './admin/pages/AdminUsers';
import AdminMedia from './admin/pages/AdminMedia';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <SettingsProvider>
            <Router>
              <Routes>
              {/* Public Routes */}
              <Route path="/" element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="hizmetler/:slug" element={<ServiceDetail />} />
                <Route path="sayfa/:slug" element={<PageDetail />} />
                <Route path="referanslar" element={<References />} />
                <Route path="iletisim" element={<Contact />} />
                <Route path="teklif-al" element={<Quote />} />
                <Route path="sizden-gelenler" element={<UserReviews />} />
                <Route path="oncesi-sonrasi" element={<BeforeAfterPage />} />
                <Route path="oncesi-sonrasi/:slug" element={<BeforeAfterDetail />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="ayarlar" element={<AdminSettings />} />
                <Route path="slider" element={<AdminSliders />} />
                <Route path="hizmetler" element={<AdminServices />} />
                <Route path="sayfalar" element={<AdminPages />} />
                <Route path="sayaclar" element={<AdminCounters />} />
                <Route path="yorumlar" element={<AdminTestimonials />} />
                <Route path="once-sonra" element={<AdminBeforeAfter />} />
                <Route path="referanslar" element={<AdminReferences />} />
                <Route path="medya" element={<AdminMedia />} />
                <Route path="mesajlar" element={<AdminMessages />} />
                <Route path="teklifler" element={<AdminQuotes />} />
                <Route path="aktivite" element={<AdminActivityLog />} />
                <Route path="kullanicilar" element={<AdminUsers />} />
              </Route>

              {/* 404 Catch-all */}
              <Route path="*" element={<NotFound />} />
              </Routes>
              <ToastContainer position="top-right" autoClose={3000} />
            </Router>
          </SettingsProvider>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
